import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getCookie } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasCookie = getCookie('name')
  // debugger
  if (hasCookie) {
    // if (to.path === '/') {
    //   getCookie('role') == 0 ? next(`/applicant`) : next(`/management`)
    // }
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next()
      NProgress.done()
    } else {
      // debugger
      const hasGetter = store.getters.name
      if (hasGetter) {
        next()
      } else {
        // debugger
        try {
          // 页面刷新就getter会清空，重新获取添加state
          const role = await store.dispatch('user/getInfo')
          // generate accessible routes map based on role
          const { routes, addRoutes } = await store.dispatch('permission/generateRoutes', [role])
          console.log('路由筛选成功')
          // dynamically add accessible routes
          router.options.routes = routes;
          router.addRoutes(addRoutes)
          next({ ...to, replace: true })


          // router.selfaddRoutes(addRoutes)
          // next()
        } catch (error) {
          console.log('重新登录')
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error('Has Error')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/

    // 查看path里是否有admin有就要登录
    if (to.path.indexOf('admin') == -1) {
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
